import "./style.css";

export default class Team {
  static selector = ".s-layout__team";

  constructor(block) {
    this.block = block;
    this.limit = parseInt(block.getAttribute("data-limit"), 10);
    this.show = true;
  }

  init() {
    this.buttonState = {
      more: this.block.getAttribute("data-button-more"),
      less: this.block.getAttribute("data-button-less"),
    };

    this.$button = this.block.querySelector(".s-button");
    this.$members = this.block.querySelectorAll(".s-team-member");
    if (this.$members.length > this.limit) {
      this.toggleList();
    }

    this.addListeners();
  }

  toggleList() {
    this.show = !this.show;
    this.$members.forEach(($el, i) => {
      if (i >= this.limit) {
        $el.classList[this.show ? "remove" : "add"]("s-team-member-hidden");
      }
    });

    this.$button.querySelectorAll("label strong").forEach(($el) => {
      $el.innerHTML = this.show ? this.buttonState.less : this.buttonState.more;
    });
  }

  addListeners() {
    this.$button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.toggleList();
    });
  }

  onReady() {
    this.init();
  }
}
